import * as React from 'react';
import { SVGProps } from 'react';

const IconLayersSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.464 1.143a1 1 0 0 0-.928 0L1.294 4.409a.6.6 0 0 0-.01 1.058l6.236 3.41a1 1 0 0 0 .96 0l6.236-3.41a.6.6 0 0 0-.01-1.058L8.464 1.143z" />
    <path d="m2.192 6.963-.88.45a.6.6 0 0 0-.016 1.06l6.224 3.405a1 1 0 0 0 .96 0l6.224-3.405a.6.6 0 0 0-.016-1.06l-.88-.45L8.48 9.878a1 1 0 0 1-.96 0L2.192 6.963z" />
    <path d="m2.192 9.963-.88.45a.6.6 0 0 0-.016 1.06l6.224 3.405a1 1 0 0 0 .96 0l6.224-3.405a.6.6 0 0 0-.016-1.06l-.88-.45-5.328 2.915a1 1 0 0 1-.96 0L2.192 9.962z" />
  </svg>
);
export default IconLayersSizeS;
